import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect, useSelector } from "react-redux";
import { EditOutlined, LogoutOutlined } from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { signOut } from "redux/actions/Auth";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { API } from "config";

const menuItem = [
    {
        title: "Edit Profile",
        icon: EditOutlined,
        path: `${APP_PREFIX_PATH}/account/settings`,
    },
];

// {
//     title: "Account Setting",
//     icon: SettingOutlined,
//     path: "/",
// },
// let user = localStorage.getItem("jwt").user;

export const NavProfile = ({ signOut }) => {
    const user = useSelector((state) => state.auth.user);
    const profileImg = `${API}/${user.image}`;
    const profileMenu = (
        <div className="nav-profile nav-dropdown">
            <div className="nav-profile-header">
                <div className="d-flex">
                    <Avatar size={45} src={profileImg} />
                    <div className="pl-3">
                        <h4 className="mb-0">{`${user.name} ${user.surname}`}</h4>
                        <span className="text-muted">{user.email}</span>
                    </div>
                </div>
            </div>
            <div className="nav-profile-body">
                <Menu>
                    {menuItem.map((el, i) => {
                        return (
                            <Menu.Item key={i}>
                                <a href={el.path}>
                                    <Icon className="mr-3" type={el.icon} />
                                    <span className="font-weight-normal">
                                        {el.title}
                                    </span>
                                </a>
                            </Menu.Item>
                        );
                    })}
                    <Menu.Item
                        key={menuItem.length + 1}
                        onClick={(e) => signOut()}
                    >
                        <span>
                            <LogoutOutlined className="mr-3" />
                            <span className="font-weight-normal">Sign Out</span>
                        </span>
                    </Menu.Item>
                </Menu>
            </div>
        </div>
    );
    return (
        <Dropdown
            placement="bottomRight"
            overlay={profileMenu}
            trigger={["click"]}
        >
            <Menu className="d-flex align-item-center" mode="horizontal">
                <Menu.Item key="profile">
                    <Avatar src={profileImg} />
                </Menu.Item>
            </Menu>
        </Dropdown>
    );
};

export default connect(null, { signOut })(NavProfile);
